import { Box, Button, DialogActions } from "@mui/material"
import type { DateView, PickersLayoutProps } from "@mui/x-date-pickers"
import type { Dayjs } from "dayjs"
import React from "react"
import type { FC, ReactElement } from "react"

interface CustomDatePickerLayoutProps extends PickersLayoutProps<Dayjs | null, Dayjs, DateView> {
  onAsap?: () => void
  onTbd?: () => void
}

const CustomDatePickerLayout: FC<CustomDatePickerLayoutProps> = ({
  children,
  onAsap,
  onTbd,
  onAccept,
  onCancel,
  onClose,
}): ReactElement => {
  const handleCustomAction = (action: () => void) => {
    action()
    onClose()
  }

  return (
    <Box>
      {children}
      <DialogActions className='justify-between'>
        <Button size='small' variant='outlined' onClick={onCancel}>
          Cancel
        </Button>

        <Box className='flex-row justify-between gap-1'>
          {onTbd && (
            <Button size='small' variant='text' onClick={() => handleCustomAction(onTbd)}>
              TBD
            </Button>
          )}

          {onAsap && (
            <Button size='small' variant='text' onClick={() => handleCustomAction(onAsap)}>
              ASAP
            </Button>
          )}
          <Button size='small' variant='contained' onClick={() => handleCustomAction(onAccept)}>
            OK
          </Button>
        </Box>
      </DialogActions>
    </Box>
  )
}
export default CustomDatePickerLayout
